import { render, staticRenderFns } from "./TemporaryItemsApproveModal.vue?vue&type=template&id=22ea5dda&scoped=true"
import script from "./TemporaryItemsApproveModal.vue?vue&type=script&lang=js"
export * from "./TemporaryItemsApproveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ea5dda",
  null
  
)

export default component.exports